
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

   
    container: () => {
        return  {
            display: 'flex',
            height: '100vh',
            width: '100%',
  
            flexDirection: 'column !important',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'scroll',
        };
      },
  
      content: ({ commonUIStyles }) => {
        function getHeight () {
          return 'calc(100%)';
        }
     
        return {
          display: 'flex',
          flexDirection: 'column !important',
          justifyContent: 'flex-start',
          alignItems: 'center',
          overflow: 'hidden',
          width: '100%',
          height: getHeight(),
    
          /* rest of css*/
          // overflowY: 'scroll',
          padding: '0px',
    
          /* for firefox*/
          scrollbarColor: 'transparent transparent',
          scrollbarWidth: '12px',
    
          '&::-webkit-scrollbar': {
              width: '12px',
              background: 'transparent',
          },
    
          '&::-webkit-scrollbar-thumb': {
              background: 'transparent',
              borderradius: '5px',
          },
    
          '&:hover': {
              'scrollbarColor': '#D9D9D9 transparent',
          },
    
        };
      },
  
      titleHeader: {
        width: '100%',
        display: 'flex',
        marginTop: '28px',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
      },
  
      oauthBeforeBody: () => {
        return  {
          width: '100%',
          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '28px 0px 78px 0px',
        };
      },
  
      subtitle: () => {
        return  {
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '20px',
        };
      },
  
      bodyMessages: () => {
        return  {
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '12px',
  
          '& .MuiTypography-root': {
            textAlign: 'center',
          },
        };
      },

      nothingHappenedMsg: () => {
        return  {
          marginTop: '28px',

          '& .MuiTypography-root': {
            fontSize: '12px',
            textAlign: 'center',
          },
        };
      },
  
      loginLink: () => {
        return  {
          cursor: 'pointer',
        };
      },
  
  
      safariLauncher: {
        display: 'none',
        position: 'absolute',
      },
    
      text: {
          color: '#FFFFFF',
          fontWeight: 'bold',
          fontSize: '20px',
      },

});

export default styles;
export const useStyles = makeStyles(styles);
